import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-report-notification',
  standalone: true,
  templateUrl: './report-notification.component.html',
  styleUrls: ['./report-notification.component.scss'],
  imports: [MatProgressSpinnerModule, MatIconModule, TranslatePipe],
})
export class ReportNotificationComponent {
  isComplete = false;
  hasError = false;
  errorMessage = '';

  private dialogRef = inject(MatDialogRef<ReportNotificationComponent>);

  closeDialog(): void {
    this.dialogRef.close();
  }

  setComplete(): void {
    this.isComplete = true;
  }

  setError(message: string): void {
    this.hasError = true;
    this.errorMessage = message;
  }
}
